import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";

import {
  SG_EMAIL_DELIVERY_STATUS,
  EMAIL_DELIVERY_STATUS,
  SG_FETCH_EMAIL_DELIVERY_STATUS,
  FETCH_EMAIL_DELIVERY_STATUS,
  ALL_ERRORS,
} from "constants/actions";
import { handleError } from "./ApiError";

function* loadTokens(action) {
  // console.log(action.payload)
  try {
    const json = yield call(api.GET_EMAIL_DELIVERY_STATUS, action.payload);
    yield put({ type: EMAIL_DELIVERY_STATUS, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* tokenLoad() {
  yield takeLatest(SG_EMAIL_DELIVERY_STATUS, loadTokens);
}

function* fetchToken(action) {
  try {
    const json = yield call(api.GET_EMAIL_DELIVERY_STATUS, action.payload);
    yield put({ type: FETCH_EMAIL_DELIVERY_STATUS, payload: json.data });
  } catch (e) {
    yield call(handleError, e);
  }
}

export function* tokenFetch() {
  yield takeLatest(SG_FETCH_EMAIL_DELIVERY_STATUS, fetchToken);
}

export default function* index() {
  yield all([tokenLoad(), tokenFetch()]);
}
